import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Box } from '@mui/material';

import 'swiper/css';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { StationRequestSlide } from './StationRequestSlide/StationRequestSlide';
import { LoyaltySlide } from './StationRequestSlide/LoyaltySlide';

export const OfferSlider = () => {
  const navigate = useNavigate();
  const slides = [
    { component: <StationRequestSlide />, action: () => navigate(ROUTES.STATIONS_REQUEST) },
    { component: <LoyaltySlide />, action: () => navigate(ROUTES.LOYALTY) },
  ];

  return (
    <Box sx={{ height: '160px', width: '100%', overflow: 'hidden' }}>
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={50}
        slidesPerView={1}
        centeredSlides={true}
        autoplay={{ delay: 5000, disableOnInteraction: true }}
        navigation
        pagination={{ clickable: true }}
      >
        {slides.map((slide) => (
          <SwiperSlide
            key={slide.action.toString()}
            style={{ borderRadius: '10px' }}
            onClick={slide.action}
          >
            {slide.component}
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
